var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{attrs:{"to":{ name: 'landing'}}},[_c('img',{staticClass:"img_logo_menu",attrs:{"src":_vm.logo,"alt":"logo"}})])}
var staticRenderFns = []

export { render, staticRenderFns }